module.exports = __webpack_public_path__ + "static/IPhone_App_Wizard_14-5c190ea7cf028c500509571be0b9b15a.png";